import { ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@/app/hooks';
import Breadcrumbs from '@/component-library/primitives/Breadcrumbs/Breadcrumbs';
import Loader from '@/component-library/primitives/Loader/Loader';
import ClerkOrganizationToolbar from '@/component-library/widgets/ClerkOrganizationToolbar/ClerkOrganizationToolbar';
import WorkspacePicker from '@/component-library/widgets/WorkspacePicker/WorkspacePicker';
import { useAuth } from '@/modules/Auth/hooks/useAuth';
import { isClerkAuthEnabled } from '@/utils/auth/authMode';
import { AppRoutes } from '@/utils/routes/router';

import { selectIsCollapsableIconHidden } from '../SideMenu/sideMenuSlice';

const LoggedInHeader = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();
  const isCollapsableIconHidden = useAppSelector(selectIsCollapsableIconHidden);
  const navigate = useNavigate();

  useEffect(() => {
    !user && navigate(AppRoutes.dashboard);
  }, [user, navigate]);

  if (!user) return <Loader />;

  return (
    <div className="flex min-h-0 min-w-0 flex-1 flex-col">
      <div className="flex h-20 min-w-0 shrink-0 items-end justify-between gap-4 px-8 pb-3.5">
        <div className={`min-w-0 flex flex-row ${isCollapsableIconHidden ? 'ml-[16.688rem]' : ''}`}>
          <Breadcrumbs />
        </div>
        <div className="flex shrink-0 items-center gap-3">
          {isClerkAuthEnabled() && <ClerkOrganizationToolbar />}
          <WorkspacePicker
            variant="toolbar"
            className="rounded-lg border border-custom-lightSilver/90 bg-white/95 shadow-[0_1px_2px_rgba(1,3,11,0.04)]"
          />
        </div>
      </div>

      <div className="min-h-0 flex-1 overflow-auto py-4 px-8 [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
        {children}
      </div>
    </div>
  );
};

export default LoggedInHeader;
